/* Ardor sticker product pages (STKBUILD, Oct 20 2026; Dayne approved in chat: "Do it now, lift freeze for these 9").
Loaded only by sections/ardor-sticker-studio-ws-ai-tpl-kit-prod.liquid (templates/product.sticker-builder-prod.json),
right BEFORE assets/ardor-sticker-ai-studio-tpl.js, so the shared sticker builder script stays unchanged.
What it does on /products/custom-*-stickers:
1. Starts the builder on this product and its selected variant (?variant= or the first one): shape or material,
   quantity and finish, like /pages/sticker-builder?product=&variant= does.
2. Until a design is added (and while shape, material, quantity and finish are still the ones of that variant), the
   Total shows that variant's own Shopify price, the same price the page prints in its HTML and in the Product
   structured data (Google Merchant Center needs the page price to match the product data).
3. The first uploaded image is sized to fit the Size fields, which start at the variant's size (instead of the builder's
   3 in default), so the price and the variant added to the cart match the option the shopper picked. They can change
   the size anytime.
Undo: remove the script tag from the section (the builder then works exactly like on /pages/sticker-builder). */
(function () {
  "use strict";
  var el = document.getElementById("wss-product");
  if (!el) return;
  var C;
  try { C = JSON.parse(el.textContent); } catch (e) { return; }
  if (!C || !C.variant) return;
  var KEYS = { die: {}, kiss: { shape: "kiss" }, circle: { shape: "circle" }, square: { shape: "square" }, rect: { shape: "rounded" },
    clear: { mat: "clear" }, holo: { mat: "holo" }, reflective: { mat: "reflective" }, hightack: { mat: "hightack" } };
  var qn = function (s) { return parseInt(String(s || "").replace(/[^\d]/g, ""), 10) || 0; };
  var money = function (c) { var v = c / 100; return "$" + (Number.isInteger(v) ? v.toLocaleString("en-US") : v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })); };
  var done = false;
  function setup() {
    var A = window.ArdorStickerStudio;
    if (done || !A || !A.state) return;
    done = true;
    var S = A.state, k = KEYS[C.key] || {}, root = document.querySelector("[data-wss]");
    if (!root) return;
    if (k.shape) S.shape = k.shape;
    if (k.mat) S.material = k.mat;
    var tiers = [];
    try {
      var D = JSON.parse(document.getElementById("wss-data").textContent), die = D.products[D.map.die];
      if (die) {
        var qi = (die.options || []).findIndex(function (o) { return String(o).toLowerCase() === "quantity"; });
        die.variants.forEach(function (v) { var t = v.o[qi]; if (tiers.indexOf(t) < 0) tiers.push(t); });
      }
    } catch (e) {}
    var ti = tiers.findIndex(function (t) { return qn(t) === qn(C.variant.qty); });
    if (ti > -1) S.qtyIndex = ti;
    if (C.variant.finish) S.laminate = C.variant.finish;
    var pin = { shape: S.shape, material: S.material, qtyIndex: S.qtyIndex, laminate: S.laminate };
    var tot = root.querySelector("[data-total]"), pr = root.querySelector("[data-priced]");
    var price = money(C.variant.price), line = C.line || "";
    function pinned() {
      return !S.cut && S.shape === pin.shape && S.material === pin.material && S.qtyIndex === pin.qtyIndex && (!C.variant.finish || S.laminate === pin.laminate);
    }
    function keep() {
      if (!tot || !pinned()) return;
      if (tot.textContent !== price) tot.textContent = price;
      if (pr && pr.textContent !== line) pr.textContent = line;
    }
    if (tot && window.MutationObserver) new MutationObserver(keep).observe(tot, { childList: true, characterData: true, subtree: true });
    // First uploaded image: fit it to the size in the Size fields (the variant's size unless the shopper changed it).
    // Finished rectangle/circle templates (wssTpl object) are placed edge to edge by the builder and are skipped.
    // Die cut / kiss cut templates (wssTpl null) are only made smaller when their cut ends up over the field size
    // (the builder prices by the next size up when the cut is more than 0.05 in over a size).
    var fc = A.canvas, wIn = root.querySelector("[data-w]"), hIn = root.querySelector("[data-h]");
    var fmt = function (n) { return String(Math.round(n * 100) / 100); };
    function fitTo(tw, th, shrinkOnly) {
      if (!S.cut || !wIn || !hIn || !(tw > 0 && th > 0)) return;
      var w = parseFloat(wIn.value), h = parseFloat(hIn.value);
      if (!(w > 0 && h > 0)) return;
      var TA = Math.max(tw, th), TB = Math.min(tw, th);
      var fits = Math.max(w, h) <= TA + 0.05 && Math.min(w, h) <= TB + 0.05;
      var f = Math.min(TA / Math.max(w, h), TB / Math.min(w, h));
      if (!isFinite(f) || (fits && (shrinkOnly || f < 1.03))) return;
      var nw = Math.floor(w * f * 10 + 1e-6) / 10, nh = Math.floor(h * f * 10 + 1e-6) / 10;
      if (!(nw > 0 && nh > 0)) return;
      wIn.value = nw; hIn.value = nh;
      wIn.dispatchEvent(new Event("change"));
      setTimeout(function () {
        try { A.toast("We sized your sticker to " + wIn.value + "\" × " + hIn.value + "\" to fit " + fmt(tw) + "\" × " + fmt(th) + "\", the size you picked. Change it anytime under Size.", 8000); } catch (e) {}
      }, 0);
    }
    if (fc && fc.on && wIn && hIn) {
      fc.on("object:added", function (e) {
        var o = e && e.target;
        if (!o || S.restoring || o.wssKind !== "image" || (o.wssTpl !== undefined && o.wssTpl !== null)) return;
        if (fc.getObjects().length !== 1) return;
        var tw = parseFloat(wIn.value), th = parseFloat(hIn.value), tpl = o.wssTpl === null;
        setTimeout(function () { fitTo(tw, th, tpl); }, 0);
      });
    }
    setTimeout(keep, 0);
  }
  document.addEventListener("ardor:sticker-studio", setup);
  if (window.ArdorStickerStudio) setup();
})();
